import React from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  SxProps,
  Theme,
} from "@mui/material";
import { ProjectRegisterOptions } from "pages/Dashboards/ProjectRegister/data/ProjectRegisterData";

interface ProjectRegisterDropdownProps {
  selectedOption: string;
  handleOptionChange: (event: SelectChangeEvent<string>) => void;
  formControlSx?: SxProps<Theme>;
  selectSx?: SxProps<Theme>;
}

const defaultSelectSx: SxProps<Theme> = {
  borderRadius: "6px",
  backgroundColor: "#fff",
  fontSize: "0.85rem",
  minHeight: 35,
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d1d5db",
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    py: 0.75,
  },
};

const mergeSx = (...styles: Array<SxProps<Theme> | undefined>): SxProps<Theme> =>
  styles.flatMap((style) => {
    if (!style) {
      return [];
    }

    return Array.isArray(style) ? [...style] : [style];
  }) as SxProps<Theme>;

const ProjectRegisterDropdown: React.FC<ProjectRegisterDropdownProps> = ({
  selectedOption,
  handleOptionChange,
  formControlSx,
  selectSx,
}) => {
  return (
    <FormControl sx={mergeSx({ minWidth: 220, ml: 1 }, formControlSx)} size="small">
      <Select
        value={selectedOption}
        onChange={handleOptionChange}
        id="projectRegisterOptionsDrodpdown"
        data-testid="projectRegisterOptionsDrodpdown"
        sx={mergeSx(defaultSelectSx, selectSx)}
        MenuProps={{
          MenuListProps: { dense: true },
          PaperProps: {
            sx: {
              "& .MuiMenuItem-root": {
                fontSize: "0.85rem",
                minHeight: 32,
                py: 0.25,
                px: 1,
              },
            },
          },
        }}
      >
        {ProjectRegisterOptions.map((option) => (
          <MenuItem key={option.id} value={option.value} sx={{ textAlign: "left", fontSize: "0.85rem" }}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ProjectRegisterDropdown;
